import { Button, cx } from '../Ui';
import type { DeliveryFilter } from './control-tower-utils';

const options: { value: DeliveryFilter; label: string }[] = [
  { value: 'todas', label: 'Todas' },
  { value: 'delivery', label: 'Delivery' },
  { value: 'pickup', label: 'Retiro' },
  { value: 'local', label: 'En el sitio' },
];

interface ControlTowerFiltersProps {
  value: DeliveryFilter;
  onChange(value: DeliveryFilter): void;
}

export function ControlTowerFilters({ value, onChange }: ControlTowerFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Filtrar por tipo de pedido">
      {options.map((option) => {
        const active = value === option.value;
        return (
          <Button
            key={option.value}
            type="button"
            variant={active ? 'primary' : 'secondary'}
            onClick={() => onChange(option.value)}
            className={cx(active && 'bg-accent text-accent-foreground')}
          >
            {option.label}
          </Button>
        );
      })}
    </div>
  );
}
